export const StampLabel = ({ text }) => (
    <div className="d-inline-block position-relative">
        <div className="bg-primary fw-semibold text-light ps-2 pe-3 skew-label">
            {text}
        </div>
    </div>
)